import React, { useState } from 'react';

import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/default/button';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import SpotlightManager from '@atlaskit/onboarding/spotlight-manager';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import SpotlightTarget from '@atlaskit/onboarding/spotlight-target';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import SpotlightTransition from '@atlaskit/onboarding/spotlight-transition';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { Pulse as SpotlightPulse } from '@atlaskit/onboarding/target';

const SpotlightPulseExample = (): React.JSX.Element => {
	const [isSpotlightActive, setIsSpotlightActive] = useState(false);
	const start = () => setIsSpotlightActive(true);
	const end = () => setIsSpotlightActive(false);
	return (
		<SpotlightManager>
			<ButtonGroup label="Choose spotlight options">
				<SpotlightTarget name="new">
					<SpotlightPulse radius={3} pulse={false}>
						<Button onClick={() => start()}>New feature</Button>
					</SpotlightPulse>
				</SpotlightTarget>
				<SpotlightTarget name="copy">
					<Button>Existing feature</Button>
				</SpotlightTarget>
			</ButtonGroup>
			<SpotlightTransition>
				{isSpotlightActive && (
					<Spotlight
						actions={[
							{
								onClick: () => end(),
								text: 'OK',
							},
						]}
						heading="Spotlight pulse"
						target="new"
						key="new"
						targetRadius={3}
						targetBgColor={'#FFFFFF'}
						pulse={false}
					>
						Announcing new features with a spotlight pulse is an onboarding pattern that you can
						explore.
					</Spotlight>
				)}
			</SpotlightTransition>
		</SpotlightManager>
	);
};

export default SpotlightPulseExample;
